/*
 * @Author: kangningbo
 * @Date:   2019-02-23 14:59:50
 * @Last Modified by:   kangningbo
 * @Last Modified time: 2019-02-23 16:18:15
 */
/* globals localStorage */
// 存储在 localStorage 的键值各系统保持一性，避免部署在同一台web服务器下服务器token相互干扰
const TOKEN_KEY = `${process.env.VUE_APP_NAME}-token`;
const USERNAME_KEY = `${process.env.VUE_APP_NAME}-username`;
const LOGINCOUNT_KEY = `${process.env.VUE_APP_NAME}-logincount`;
const LOCAL_KEY = `${process.env.VUE_APP_NAME}-local`;

export default {
  setLangCookie(lang) {},
  getToken() {
    return localStorage[TOKEN_KEY];
  },
  /* bengin: 2022-05-11, 刷新token值 */
  setRefreshToken(token) {
    if (localStorage[`${TOKEN_KEY}-refresh`] !== token) {
      localStorage[`${TOKEN_KEY}-refresh`] = token;
    }
  },
  getRefreshToken() {
    return localStorage[`${TOKEN_KEY}-refresh`];
  },
  // end：2022-05-11

  /**
   * 删除token，浏览器关闭会保留token，因此当重新打开浏览器时，会读取到上一次token请求数据
   * 如果重新打开时不想使用上一次token,可以在 src/config/interceptors/router.js
   * 方法：routerBeforeEachFunc 中移除
   */
  deleteToken() {
    delete localStorage[TOKEN_KEY];
  },

  setToken(token) {
    if (localStorage[TOKEN_KEY] !== token) {
      localStorage[TOKEN_KEY] = token;
    }
  },

  setUserName(name) {
    localStorage[USERNAME_KEY] = name;
  },

  /* 设置终端 */
  setDevirce(devirce) {
    localStorage.appDevirce = devirce;
  },

  /* 获取终端 */
  getDevirce() {
    return localStorage.appDevirce;
  },

  getUserName() {
    return localStorage[USERNAME_KEY];
  },

  // 设置用户session
  setUserInfo(name) {
    sessionStorage[USERNAME_KEY] = name;
  },

  getUserInfo() {
    return sessionStorage[USERNAME_KEY];
  },
  // end

  logout(cb) {
    delete localStorage[TOKEN_KEY];
    delete localStorage[`${TOKEN_KEY}-refresh`];
    if (cb) {
      cb();
    }
    this.onChange(false);
  },

  loggedIn() {
    return !!localStorage[TOKEN_KEY];
  },

  getLoginCount() {
    return localStorage[LOGINCOUNT_KEY] || 0;
  },

  setLoginCount(count) {
    localStorage[LOGINCOUNT_KEY] = count;
  },

  /**
   * 设置语言
   */
  setLocal(local) {
    this.setValue(LOCAL_KEY, local);
  },
  getLocal() {
    const broswerLang = navigator.language || navigator.userLanguage || navigator.browserLanguage;
    let defaultLang = 'zh-CN';
    if (broswerLang.indexOf('en') > -1) {
      defaultLang = 'en-US';
    }
    return localStorage[LOCAL_KEY] || defaultLang;
  },
  /**
   * 描述 在localStorage 和 Cookies 同时设置
   * @date 2021-04-09
   * @param {any} key
   * @param {any} value
   * @returns {any}
   */
  setValue(key, value) {
    localStorage[key] = value;
    // Cookies.set(key, value);
  },

  onChange() {},

  // 设置客户端id
  setClientId(id) {
    localStorage[`${process.env.VUE_APP_NAME}-clientId`] = id;
  },
  getClientId() {
    return localStorage[`${process.env.VUE_APP_NAME}-clientId`];
  },
};
